<nav-bar (sidenavToggle)="sidenavToggle()" [displayGoToTopButton]="displayGoToTopButton" [goToTopButtonOpacity]="goToTopButtonOpacity" [sidenavOpened]="sidenav.opened"></nav-bar>
<mat-sidenav-container (window:resize)="onResize()">
    <mat-sidenav class="mat-sidenav" #sidenav role="navigation" position="end" mode="over">
        <sideMenu (sidenavClose)="sidenav.close()" [currentlanguage]="currentLanguage"></sideMenu>
    </mat-sidenav>
    <mat-sidenav-content>
        <img class="headerPaint" id="ImgHeaderIWL" src="assets/ImgHeaderIWL.png" alt="" />
        <main (scroll)="refreshGoToTopButton($event)">
            <a id="topanchor"></a>
            <router-outlet></router-outlet>
            <div *ngIf="isTchat">
                <app-tchat-assistance></app-tchat-assistance>
            </div>
            <div class="footer">
                <div class="flex flex-column flex-nowrap">
                    <img id="footermargin" src="assets/bandeau/ImgFooterIWL.png" alt="" />
                    <div class="coloredFooter" id="footerimg">
                        <img class="footerTransition" src="assets/ImgHeaderIWL.png" alt="" />
                        <img class="footerLogo" src="assets/bandeau/logo.svg" alt="" />
                    </div>
                    <div class="coloredFooter" id="footerimg-m">
                        <img class="footerTransition" src="assets/ImgHeaderIWL.png" alt="" />
                        <img class="footerLogo" src="assets/bandeau/logo.svg" alt="" />
                    </div>
                    <p class="text-black footerCgu pointer" (click)="openCGU()"> <span [translate]="'common.cgu'"> </span> &copy; Lacour Electronique  </p>
                </div>
                <p class="footerVersion"> {{'common.version'|translate}}: {{version}}</p>
            </div>
            <div id="ModalCGU" class="modal">
                <div class="modal-content cgucontent">
                    <div class="flex flex-row justify-content-between">
                        <div class="cgu-menu">
                            <nav>
                                <button class="text-right pointer goToBtn" (click)="toggleCGUNav()">
                                    Aller à <i class="fa-solid fa-caret-down"></i>
                                </button>
                                <div id="cgu-menu-sections" [style.display]="(displayCGUNav ? null : 'none')"></div>
                            </nav>
                        </div>
                        <h1 class="text-right pointer close" (click)="closeCGU()">
                            <i aria-hidden="true" class="fal fa-times primaryRed"></i>
                        </h1>
                    </div>
                    <app-cgu class="cguModalComp" (langChange)="cguLangChange()">
                    </app-cgu>
                </div>
            </div>
        </main>
    </mat-sidenav-content>
</mat-sidenav-container>
<update *ngIf="displayUpdate" (destroy)="destroy()"></update>



<!--Modale Loading-->
<div id="loadingModalGlobal" class="modal">
    <div class="modal-content" id="loadingContentGlobal">

        <div class="loadingGlobal">
            <img src="assets/loading.svg" alt="{{'stats.common.loading'|translate}}" />
        </div>
    </div>
</div>

<!--<div id="loadingModalGlobal" class="modal">
    <div class="modal-content" id="loadingModalGlobal">
        <div class="col-12 mt-5 mb-5 row justify-content-center loader-black">
            <mat-spinner diameter="70"> </mat-spinner>
        </div>
    </div>
</div>-->
